import 'react-app-polyfill/ie9'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './screens'
import registerServiceWorker from './registerServiceWorker'
import './scss/app.scss'
import '../node_modules/react-datetime/css/react-datetime.css'
ReactDOM.render(<App />, document.getElementById('root'))

registerServiceWorker()
